import { useQuarantineDefectV1ControllerGetById } from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';

export const useGetQuarantineDefectData = (id: string) => {
  const { data: session } = useSession();

  const { data, error, isLoading } = useQuarantineDefectV1ControllerGetById(
    {
      pathParams: { id },
    },
    {
      enabled: !!session?.user.projectId && !!id,
    },
  );

  return {
    data,
    isLoading,
    error,
  };
};
